import { Grid } from '@material-ui/core';
import { EntityAboutCard, EntityLayout, EntityLinksCard } from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { EntityWarningContent } from './modules/EntityWarningContent';

function Overview() {
  return (
    <Grid container spacing={3} alignItems="stretch">
      <EntityWarningContent />
      <Grid item md={8}>
        <EntityAboutCard />
      </Grid>
      <Grid item md={4} xs={12}>
        <EntityLinksCard />
      </Grid>
    <Grid item md={12}>
        <EntityCatalogGraphCard />
    </Grid>
    </Grid>
  );
}

export const resourcePage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Overview />
    </EntityLayout.Route>
  </EntityLayout>
);
